export const CURRENT_YEAR = new Date().getFullYear();

export const YEAR_OPTIONS = Array.from({ length: 7 }, (_, i) => {
  const y = CURRENT_YEAR + 1 - i;
  return { value: String(y), label: String(y) };
});

export const PERIOD_OPTIONS = [
  { value: "month", label: "Tháng" },
  { value: "quarter", label: "Quý" },
  { value: "annual", label: "Năm" },
];

export const MONTH_OPTIONS = Array.from({ length: 12 }, (_, i) => ({
  value: String(i + 1),
  label: `Tháng ${i + 1}`,
}));

export const QUARTER_OPTIONS = [
  { value: "1", label: "Quý 1" },
  { value: "2", label: "Quý 2" },
  { value: "3", label: "Quý 3" },
  { value: "4", label: "Quý 4" },
];
